module.exports = {
    english: "Angličtina",
    slovak: "Slovenčina",
    deutsch: "Nemčina",
    log_in_using_local_account: "Prihlásenie pomocou lokálneho účtu",
    user: "Používateľ",
    password: "Heslo",
    ws_icon_connected: "Pripojené",
    ws_icon_not_connected: "Spojenie vypršalo"
}